import { Pencil, Trash2 } from "lucide-react";
import { FieldInput } from "./DiaryInputs";
import { fieldDisplay, isBlank } from "./diaryUtils";

function FollowUp({ fields, entry, onChange, testId }) {
  return (
    <div className="mt-3 space-y-4 rounded-xl bg-sky-50 p-3" data-testid={`${testId}-followup`}>
      <div className="text-sm font-semibold uppercase tracking-[0.15em] text-sky-900">The next day</div>
      {fields.map((f) => (
        <div key={f.code}>
          <div className="mb-2 text-base font-semibold text-zinc-900">{f.prompt}</div>
          <FieldInput field={f} value={entry[f.code]} onChange={(v) => onChange({ ...entry, [f.code]: v })} testId={`${testId}-${f.code}`} />
        </div>
      ))}
    </div>
  );
}

/** One logged entry: summary line, edit/delete, and next-day questions once they open. */
export function EntryCard({ entry, entryFields, followupFields, followupOpen, readOnly, onEdit, onDelete, onChange, testId }) {
  const [title, ...rest] = entryFields;
  const details = rest.filter((f) => !isBlank(entry[f.code])).map((f) => `${f.prompt.replace(/\s*\(.*\)$/, "").replace(/\?$/, "")}: ${fieldDisplay(f, entry[f.code])}`);
  return (
    <li className="rounded-xl border border-zinc-200 bg-white p-3" data-testid={testId}>
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          <div className="text-lg font-semibold text-zinc-950">{entry[title.code]}</div>
          {details.length > 0 && <div className="mt-0.5 text-base text-zinc-700">{details.join(" · ")}</div>}
          {!followupOpen && followupFields.length > 0 && <div className="mt-1 text-sm text-zinc-500">Recovery questions open tomorrow.</div>}
        </div>
        {!readOnly && (
          <div className="flex gap-1">
            <button type="button" onClick={onEdit} className="rounded-lg p-2.5 text-zinc-600 hover:bg-zinc-100" aria-label="Edit" data-testid={`${testId}-edit`}><Pencil className="h-5 w-5" /></button>
            <button type="button" onClick={onDelete} className="rounded-lg p-2.5 text-red-700 hover:bg-red-50" aria-label="Delete" data-testid={`${testId}-delete`}><Trash2 className="h-5 w-5" /></button>
          </div>
        )}
      </div>
      {followupOpen && followupFields.length > 0 && !readOnly && <FollowUp fields={followupFields} entry={entry} onChange={onChange} testId={testId} />}
    </li>
  );
}
